<table
  class="app-table-skeleton"
  role="presentation"
  [attr.aria-hidden]="true"
>
  <thead *ngIf="showHeader" class="app-table-skeleton__head">
    <tr>
      <th *ngFor="let _ of colIndices" class="app-table-skeleton__th" scope="col">
        <app-skeleton [className]="headerCellSkeletonClassName"></app-skeleton>
      </th>
    </tr>
  </thead>
  <tbody class="app-table-skeleton__body">
    <tr *ngFor="let _ of rowIndices" class="app-table-skeleton__row">
      <td *ngFor="let __ of colIndices" class="app-table-skeleton__td">
        <app-skeleton [className]="cellSkeletonClassName"></app-skeleton>
      </td>
    </tr>
  </tbody>
</table>
